import { useInjection } from "@presentation/components/dependencyInjection";
import { TYPES } from "@utils/inversifyJS/types";
import type { DeleteRawFileService } from "@application/useCases/rawFiles/DeleteRawFileService";
import { useDeleteFileDialog, type DeleteTarget } from "@presentation/components/helpers/useDeleteFileDialog";
import { PathTypeSchema } from "@domain/schemas/BI";

export const useDeleteRawFileDialog = (options: { projectId: string | null | undefined; onDeleted: (target: DeleteTarget) => void | Promise<void> }) => {
  const service = useInjection<DeleteRawFileService>(TYPES.DeleteRawFileService);
  const { deleteFileDialog, openDeleteDialog } = useDeleteFileDialog({
    ...options,
    pathType: PathTypeSchema.Raw,
    getUsage: (target) => service.getUsageAsync(target.projectId, target.fileName, target.folder || undefined, target.isFolder, target.sourcePath),
    deleteFile: (target) => service.executeAsync(target.projectId, target.fileName, target.folder || undefined, target.isFolder, target.sourcePath),
  });
  return { deleteRawFileDialog: deleteFileDialog, openDeleteDialog };
};

export type { DeleteTarget } from "@presentation/components/helpers/useDeleteFileDialog";
